import { V2_COMPANY_ROUTE } from '@constants'

export const API_COMPANY_DOCUMENTS_URL = `${V2_COMPANY_ROUTE}document/`
export const API_COMPANY_DOCUMENT_URL = `${API_COMPANY_DOCUMENTS_URL}{document_id}/`
